module.exports = __webpack_public_path__ + "img/title-6.fae30a53.png";